import type { ReactNode } from "react";
import { MARK_LINK, MARK_STYLED } from "storyblok-rich-text-react-renderer";
import type { LinkProps } from "../../RichtextResolvers/Link/Link.d";
import type { RichtextAdapterProps } from "../../RichtextAdapter.d";
import { Link, Styled } from "../../RichtextResolvers";

export const getMarkResolvers = ({ customStyles }: { customStyles: RichtextAdapterProps["customStyles"] }) => ({
  [MARK_LINK]: (children: ReactNode, { href, target, linktype, uuid }: LinkProps) => (
    <Link href={href} target={target} linktype={linktype} styles={customStyles?.link} uuid={uuid}>
      {children}
    </Link>
  ),
  [MARK_STYLED]: (children: ReactNode, { class: className }: { class: string }) => (
    <Styled className={className}>{children}</Styled>
  ),
});
